













































































import Vue from "vue";
import Component from "vue-class-component";
import { Prop } from "vue-property-decorator";

@Component
export default class ErrorBanner extends Vue {
  @Prop({ default: 10 }) secondsToClose!: number;
  @Prop({ default: "" }) classes!: number;
  public error: string = "";
  public showing: boolean = false;
  public show(error: string = "", secondsToClose?: number) {
    this.error = error;
    this.showing = true;
    if (
      this.error
        .toString()
        .trim()
        .toLowerCase() === "Network Error".toLowerCase()
    ) {
      this.error = this.$i18n.t("shared.networkError").toString();
    }
    if (secondsToClose && secondsToClose > 0) {
      this.secondsToClose = secondsToClose;
    }
    if (this.secondsToClose > 0) {
      setTimeout(() => {
        this.close();
      }, this.secondsToClose * 1000);
    }
  }
  public close() {
    this.$emit("closed");
    this.showing = false;
  }
}
